export interface Link {
    url:    null | string;
    label:  string;
    active: boolean;
}
